import gql from 'graphql-tag'

export default gql`query editSchedule{
    editSchedule @client{
        id
        start_date
        end_date
        user_schedule_type_id
        project_activity_budget_id
        user_id
        active
    }
}`